import { tprStorage } from "@/core/storage";
import { authClient } from "@/lib/auth-client";
import { useNavigate } from "react-router";

export const useLogout = () => {
  const navigate = useNavigate();

  return async () => {
    await authClient.signOut();

    // Clear bearer token from storage
    sessionStorage.removeItem('tpr-bearer-token');

    tprStorage.remove("tpruser");
    navigate("/login", { replace: true });
  };
};
